import * as yup from 'yup';

const createTransactionNoteSchema = yup.object().shape({
  note: yup.string().required('Note is mandatory'),
});

export default createTransactionNoteSchema;
